<script>
  /**
   * Status / condition pill with semantic colors:
   * green = good standing, blue = in use, amber = temporarily away,
   * red = problem, gray = out of inventory / unknown,
   * brown = disposed of (recycled / trashed — end of life).
   */
  let { value = '', class: className = '' } = $props();

  const TONE_BY_VALUE = {
    // statuses
    stored: 'ok',
    in_use: 'info',
    lent: 'warn',
    borrowed: 'warn',
    lost: 'bad',
    stolen: 'bad',
    sold: 'neutral',
    donated: 'neutral',
    gifted: 'neutral',
    recycled: 'dispose',
    trashed: 'dispose',
    // conditions
    new: 'ok',
    excellent: 'ok',
    good: 'ok',
    fair: 'warn',
    worn: 'warn',
    poor: 'bad',
    damaged: 'bad',
    broken: 'bad',
  };

  const tone = $derived(TONE_BY_VALUE[String(value).toLowerCase()] || 'neutral');
  const label = $derived(
    String(value)
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );
</script>

{#if value}
  <span class={`status-badge tone-${tone} ${className}`}>
    <span class="dot"></span>{label}
  </span>
{/if}

<style>
  .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11.5px;
    font-weight: 600;
    border-radius: 999px;
    padding: 2px 9px;
    white-space: nowrap;
  }
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
  .tone-ok      { background: #ecfdf5; color: #047857; }
  .tone-ok .dot { background: #10b981; }
  .tone-warn      { background: #fffbeb; color: #b45309; }
  .tone-warn .dot { background: #f59e0b; }
  .tone-bad      { background: #fef2f2; color: #b91c1c; }
  .tone-bad .dot { background: #ef4444; }
  .tone-info      { background: #eff6ff; color: #1d4ed8; }
  .tone-info .dot { background: #3b82f6; }
  .tone-neutral      { background: #f3f4f6; color: #4b5563; }
  .tone-neutral .dot { background: #9ca3af; }
  /* Disposed of (recycled / trashed): a muted brown — reads as "gone / waste"
     without the alarm of the red problem tone. */
  .tone-dispose      { background: #f5f0eb; color: #8a5a44; }
  .tone-dispose .dot { background: #a87c5f; }
</style>
